// extracted by mini-css-extract-plugin
export default {"formContainer":"applyEmployee_formContainer__slbxe","submitButton":"applyEmployee_submitButton__NYE98","errorMessage":"applyEmployee_errorMessage__2vs5I"};